export class RootURL {
  static ApiBase = process.env.REACT_APP_API_URL;
}
